import { render, staticRenderFns } from "./PatientInsurancesRep.vue?vue&type=template&id=0ca7d3d0&"
import script from "./PatientInsurancesRep.vue?vue&type=script&lang=js&"
export * from "./PatientInsurancesRep.vue?vue&type=script&lang=js&"
import style0 from "./PatientInsurancesRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports